import type { AxiosResponse } from "axios";
import { AxiosError } from "axios";
import { createQuery } from "react-query-kit";

import type { ID } from "@constants";
import { generatePath } from "@routes/generatePath.ts";
import type { IShowAppointmentEndpoint } from "@api/appointment/types";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient } from "@/api";

const key = "show-appointment";

type IResponse = AxiosResponse<IApiResponse<IShowAppointmentEndpoint>>;
interface IVariables {
  appointmentId: ID;
}

export const showAppointment: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.get(
    generatePath("/appointments/:appointment_id", {
      appointment_id: params?.appointmentId,
    }),
    {
      params,
      signal,
    },
  );
};

export const useShowAppointment = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    showAppointment(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
});
